// extracted by mini-css-extract-plugin
export default {"overlay":"GI-z","bodyOpen":"HI-z","content":"II-z","header":"JI-z","close":"KI-z","closeNoHeading":"LI-z"};